import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { truncateString } from "utils/others";
import useTailwindBreakpoints from "utils/useTailwindBreakPoints";

const disabledSegments = ["license", "visa", "management"];
const Breadcrumbs: FC = () => {
  const location = useLocation();
  const { isSm } = useTailwindBreakpoints();

  const pathnames = location.pathname.split("/").filter(Boolean);

  const shouldSkipDisplay = (value: string, index: number) => {
    const isLast = index === pathnames.length - 1;
    return isSm && (isLast || value === "edit" || value === "show");
  };

  const isSegmentDisabled = (segment: string) => {
    return disabledSegments.includes(segment);
  };

  return (
    <div className="md:block">
      <div className="flex items-center h-full">
        <nav aria-label="breadcrumb">
          <ol className="flex space-x-2">
            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join("/")}`;
              const isLast = index === pathnames.length - 1;
              const displayValue = value.replace(/_/g, " ");
              const truncatedValue = truncateString(displayValue);
              const isDisabled = isSegmentDisabled(value);

              if (shouldSkipDisplay(value, index)) {
                return null;
              }

              if (isLast) {
                return (
                  <li key={to} className="capitalize text-xs text-gray-600" aria-current="page">
                    {truncatedValue}
                  </li>
                );
              }

              return (
                <li key={to} className="capitalize text-xs">
                  {isDisabled ? (
                    <span className="text-gray-400 cursor-not-allowed">{displayValue}</span>
                  ) : (
                    <Link to={to} className="text-primary hover:underline">
                      {displayValue}
                    </Link>
                  )}
                  <span className="mx-2">/</span>
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumbs;
